import {Component, inject, input} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Fluid} from 'primeng/fluid';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-registration-success',
  imports: [Fluid, TranslocoPipe],
  templateUrl: './registration-success.component.html',
  styleUrl: './registration-success.component.scss',
})
export class RegistrationSuccessComponent {
  private readonly sso = inject(ActivatedRoute).snapshot.queryParamMap.get('sso') === 'true';

  readonly iconClass = input(this.sso ? 'pi pi-sign-in' : 'pi pi-envelope');
  readonly titleKey = input(
    this.sso ? 'account.register.ssoRegistrationSuccess' : 'account.register.registrationSuccess',
  );
  readonly messageKey = input(
    this.sso
      ? 'account.register.ssoRegistrationSuccessInfo'
      : 'account.register.registrationSuccessInfo',
  );
}
